<template>
    <modal-dialog
        v-if="!!project"
        id="rescope-dialog"
        :show.sync="shown"
        class="rescope-dialog"
    >
        <template v-slot:title>
            Re-scope Project {{ project.number }} {{ project.name }}
        </template>

        <div class="uk-flex uk-flex-center">
            <div
                v-for="(new_scope, index) in new_scopes"
                :key="index"
                class="uk-width-1-3 uk-panel uk-panel-box uk-margin-small-left uk-margin-small-right"
            >
                <h3 class="uk-panel-title">
                    <span v-if="!index">Original</span>
                    <span v-else>New Project {{index}}</span>
                </h3>

                <draggable
                    :id="`scope-${index}`"
                    :list="new_scope"
                    tag="ul"
                    group="scopes"
                    :sort="false"
                    handle="li"
                    filter=".lam-rooted"
                    ghostClass="lam-dropzone"
                    dragClass="lam-dragging"
                >
                    <li
                        v-for="project in new_scope"
                        :key="project.id"
                        :class="{ 'lam-rooted': !index && (project.number_suffix === '00'), 'uk-text-muted': !index && (project.number_suffix === '00') }"
                    >
                        {{ project.number_suffix }} {{ project.nickname || project.name }}
                    </li>
                    <li
                        v-if="!new_scope.length"
                        class="uk-text-muted lam-rooted"
                    >
                        (Ignored)
                    </li>
                </draggable>
            </div>
        </div>

        <div class="uk-modal-footer uk-text-center">
            <base-button
                size="large"
                class="uk-margin-small-right"
                @click.native.prevent="shown = false"
            >
                Cancel
            </base-button>
            <base-button
                :waiting="saving"
                size="large"
                class="uk-margin-small-left"
                @click.native.prevent="save"
            >
                Re-scope
            </base-button>
        </div>
    </modal-dialog>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"
import { orderBy } from "lodash"

import ModalDialog from "../../dialogs/ModalDialog/ModalDialog"
import BaseButton from "../../ui/BaseButton"
import draggable from "vuedraggable"

export default {
    components: {
        ModalDialog,
        BaseButton,
        draggable
    },
    mounted () {
        this.reset()
    },
    watch: {
        show: "reset",
        "project.id": "reset"
    },
    methods: {
        reset () {
            if(this.show && this.project && this.project.id) {
                // load latest proposal for total amount ; phases have been loaded by editor already
                const scopes = this.project_scopes.slice(0)
                const new_scope = [scopes.pop()]
                this.new_scopes = [
                    scopes,
                    new_scope
                ]
                for(var loop = 2; loop < scopes.length; loop++) this.new_scopes.push([])
            }
        },
        save () {
            const data = { scope_project_ids: [] }
            for(var loop = 0; loop < this.new_scopes.length; loop++) {
                if(this.new_scopes[loop].length) {
                    data.scope_project_ids.push(this.new_scopes[loop].map(project => project.id))
                }
            }

            this.saving = true
            this.$store.dispatch("RECORD_ACTION", {
                entity: "project",
                id: this.project.id,
                action: "rescope",
                data,
                method: "post"
            }).then(() => {
                this.shown = false
                this.$emit("scoped")
            }).catch(error => {
                this.$error(error.message)
            }).then(() => {
                this.save = false
            })
        },
        close () {
            this.$emit("update:show", false)
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        state_identifier () {
            return "rescope-dialog"
        },
        shown: {
            get: function () {
                return this.show
            },
            set: function (show) {
                if(!show) this.close()
            }
        },
        raw_project_scopes () {
            if(!this.project) return []
            return this.entity_records("project").filter(project => project.number === this.project.number)
        },
        project_scopes () {
            return orderBy(this.raw_project_scopes, "number_suffix", "asc")
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        project: {
            type: Object,
            required: true
        },
        fields: {
            type: Array,
            required: true
        },
        relationIds: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            new_scopes: [],
            saving: false
        }
    }
}
</script>

<style lang="less">
.rescope-dialog {
    .uk-panel-box {
        border-color: #ddd;
    }
    ul {
        list-style: none;
        padding-left: 0;

        & > li {
            &:not(.lam-rooted) {
                cursor: grab;
            }
        }
    }
}
</style>
